$('html').on('click', '.miniFrame .miniframefeed', function(){
    if($(this).find('.play').length>0){
        console.log('aaaa')
        $.colorbox({
            html: '<div class="iframeColorbox"><iframe width="640" height="390" src="'+$(this).data('iframe')+'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>',
            width: 700,
            maxWidth: "95%",
            height: 400,
            maxHeight: "95%",
            className: "framevideo",
            onComplete: function() {
                $.colorbox.resize()
            }
        })
    }
    else{
        $.colorbox({
            html: '<div class="imageColorbox"><img src="'+$(this).data('iframe')+'"></div>',
            width: 700,
            maxWidth: "95%",
            height: 400,
            maxHeight: "95%",
            className: "frameimage",
            onComplete: function() {
                
            }
        })
    }
})